import { IReport, IReportReason, IReportStatus } from 'interfaces/reports';
import { IUser } from '../../../../interfaces/users';
import {
  REPORT_REASON_MAP,
  REPORT_STATUSES_WITH_COLOR_MAP
} from 'services/report';
import { ShowButton, TagField, TextField } from '@refinedev/antd';
import { Space, Table, TableProps } from 'antd';
import { formatDate } from 'services/date';
import { truncate } from 'lodash-es';

interface ReportsTableProps {
  tableProps: TableProps<IReport>;
}

export const ReportsTable = ({ tableProps }: ReportsTableProps) => {
  return (
    <Table {...tableProps} rowKey="id">
      <Table.Column
        dataIndex="reason"
        key="reason"
        title="Motivo"
        render={value => (
          <TextField value={REPORT_REASON_MAP[value as IReportReason]} />
        )}
      />

      <Table.Column
        dataIndex="text"
        key="text"
        title="Texto"
        render={value => <TextField value={truncate(value, { length: 150 })} />}
      />
      <Table.Column
        dataIndex="status"
        key="status"
        title="Status"
        render={value => (
          <TagField
            color={REPORT_STATUSES_WITH_COLOR_MAP[value as IReportStatus].color}
            value={REPORT_STATUSES_WITH_COLOR_MAP[value as IReportStatus].text}
          />
        )}
      />
      <Table.Column
        dataIndex="created_at"
        key="created_at"
        title="Data de criação"
        render={value => <TextField value={formatDate(value)} />}
      />
      <Table.Column<IUser>
        title="Ações"
        dataIndex="actions"
        align="center"
        width={80}
        render={(_, record) => {
          return (
            <Space>
              <ShowButton hideText size="small" recordItemId={record.id} />
            </Space>
          );
        }}
      />
    </Table>
  );
};
